"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _themeGet = require("@styled-system/theme-get");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = _styledComponents["default"].div.withConfig({
  componentId: "sc-9d0wsn-0"
})(["display:flex;align-items:baseline;font-size:", "px;color:", ";"], (0, _themeGet.themeGet)('fontSizes.0'), (0, _themeGet.themeGet)('colors.black'));

var Tags = _styledComponents["default"].div.withConfig({
  componentId: "sc-9d0wsn-1"
})(["display:inline-block;padding:0 ", "px;"], (0, _themeGet.themeGet)('space.2'));

var Title = _styledComponents["default"].span.withConfig({
  componentId: "sc-9d0wsn-2"
})(["font-size:", "px;font-weight:", ";text-transform:uppercase;"], (0, _themeGet.themeGet)('fontSizes.0'), (0, _themeGet.themeGet)('fontWeights.bold'));

var StyledBadge = (0, _styledComponents["default"])(_pclnDesignSystem.Badge).withConfig({
  componentId: "sc-9d0wsn-3"
})(["text-transform:capitalize;font-weight:normal;margin-right:", "px;margin-bottom:", "px;border-radius:", "px;"], (0, _themeGet.themeGet)('space.1'), (0, _themeGet.themeGet)('space.1'), (0, _themeGet.themeGet)('space.2'));
var TagList = (0, _react.memo)(function (_ref) {
  var title = _ref.title,
      tags = _ref.tags,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["title", "tags", "color"]);

  return _react["default"].createElement(Container, props, _react["default"].createElement(Title, null, title, ":"), _react["default"].createElement(Tags, null, tags.map(function (tag) {
    return _react["default"].createElement(StyledBadge, {
      color: color,
      key: tag
    }, tag);
  })));
});
TagList.displayName = 'TagList';
TagList.propTypes = {
  tags: _propTypes["default"].arrayOf(_propTypes["default"].string),
  title: _propTypes["default"].string,
  color: _propTypes["default"].string
};
TagList.defaultProps = {
  tags: [],
  title: 'Tags',
  color: 'primary'
};
var _default = TagList;
exports["default"] = _default;